<template>
  <span>{{currentRateResult}}</span>
</template>

<script>
export default {
  props: {
    currencyCode: {
      required: true,
      type: String
    },
    onDateAsString: {
      required: true,
      type: String
    },
    source: {
      // CBR API Or Import,
      required: true,
      type: String
    }
  },
  data() {
    return {
      currentRateResult: `${this.$t('CONTENT.currency.download_currency')}...`
    };
  },
  async created() {
    await this.calculateCurrencyRate();
  },
  methods: {
    async calculateCurrencyRate() {
      let currentRate = null;
      if (this.currencyCode !== null && this.onDateAsString !== null) {
        try {
          if (this.source === "CBR API") {
            currentRate = await this.$store.dispatch("getCurrencyRateFromCBR", {
              date: encodeURIComponent(this.onDateAsString),
              currencyCode: this.currencyCode,
            });
          } else {
            currentRate = await this.$store.dispatch(
              "getCurrencyRateFromImport",
              {
                date: encodeURIComponent(this.onDateAsString),
                currencyCode: this.currencyCode,
                importedId: this.source,
              },
            );
          }
          this.currentRateResult = currentRate.value;
        } catch (e) {
          const error = e;
          console.error(error);
          this.currentRateResult = this.$t('CONTENT.no_data');
        }
      } else {
        this.currentRateResult = this.$t('CONTENT.currency.choose_date_currency');
      }
    }
  }
};
</script>

<style>
</style>
